import React from "react";
import { IProdutoVariacao } from "shared/interfaces/IProduto";
import styles from "./SeletorVariacoes.module.scss";
import { SelecaoCombinacao } from "./useSelecaoCombinacao";

interface SeletorVariacoesProps {
  variacoes: IProdutoVariacao[];
  selecao: SelecaoCombinacao;
}

/** Um grupo de opções por variação, com o título que o admin definiu. */
export const SeletorVariacoes: React.FC<SeletorVariacoesProps> = ({
  variacoes,
  selecao,
}) => (
  <div className={styles.container}>
    {variacoes.map((variacao) => (
      <div className={styles.grupo} key={variacao.id}>
        <p className={styles.titulo}>{variacao.title}</p>
        <div className={styles.opcoes}>
          {variacao.values.map((valor) => {
            const { visivel, habilitado } = selecao.estadoDoValor(
              variacao.id,
              valor.id,
            );
            // Combinação que a loja não vende com o que já foi escolhido:
            // o valor nem aparece.
            if (!visivel) return null;
            const escolhido = selecao.selecao[variacao.id] === valor.id;
            return (
              <button
                type="button"
                key={valor.id}
                className={[
                  styles.opcao,
                  escolhido ? styles.escolhida : "",
                ].join(" ")}
                disabled={!habilitado}
                aria-pressed={escolhido}
                title={habilitado ? undefined : "Esgotado"}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  selecao.selecionar(variacao.id, valor.id);
                }}
              >
                {valor.display}
              </button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);
